import { defaultGroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { isFieldFilterValid } from 'module/types/filter-field/grouped-filter/utils';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { GroupedFilterAsBadges } from 'module/ui/components/molecules/field-filter/as-badges/grouped-filter-as-badges';
import { Button } from '@rocketlane/ui';
import { ICellRendererParams } from 'ag-grid-community';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SectionData } from '../types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const FilterWrapper = styled(CenterAlignedBox)`
  cursor: pointer;
`;

interface Props extends ICellRendererParams<SectionData> {
  onEditFilter: (section: SectionData) => void;
}
export const FilterCell: FC<Props> = ({ data, onEditFilter }) => {
  const hasSomeValidFilter = useMemo(() => {
    return data?.filter?.groupCriteria.some(({ criteria }) =>
      isFieldFilterValid(criteria),
    );
  }, [data]);

  if (data == null) {
    return null;
  }

  return hasSomeValidFilter ? (
    <FilterWrapper onClick={() => onEditFilter(data)}>
      <GroupedFilterAsBadges
        filter={data.filter ?? defaultGroupedFilter(FilterGroupType.User)}
      />
    </FilterWrapper>
  ) : (
    <Wrapper>
      <FormattedMessage id="people_page_templates.dynamic_section.table.filter.no_filter" />
      <Button variant="link" onClick={() => onEditFilter(data)}>
        <FormattedMessage id="meeting_page_template_add_conditions" />
      </Button>
    </Wrapper>
  );
};
